<div class="contenedor-form">
  <form [formGroup]="filtroGroup" (ngSubmit)="busqueda()" class="example-form">
    <div class="row">
      <div class="col s12 m6 l2">
        <span *ngIf="loadingAgencias">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px;"
          ></mat-spinner>
        </span>
        <span *ngIf="!loadingAgencias">
          <mat-form-field>
            <mat-label>AGENCIA</mat-label>
            <mat-select
              formControlName="idAgencia"
              (change)="cargarUsuariosAgencia()"
            >
              <mat-option *ngFor="let agencia of agencias" [value]="agencia.id">
                {{ agencia.valor }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div class="col s12 m6 l2">
        <span *ngIf="loadingUsuarios">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px;"
          ></mat-spinner>
        </span>
        <span *ngIf="!loadingUsuarios">
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Vendedor"
              [matAutocomplete]="auto"
              formControlName="usuarioCtrl"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option
                *ngFor="let usuario of filteredUsuarios | async"
                [value]="usuario"
              >
                <span>{{ usuario.valor }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
      <div class="col s12 m6 l2">
        <span *ngIf="loadingDistribuidoras">
          <mat-spinner
            [diameter]="30"
            style="margin: 0 auto; top: 15px;"
          ></mat-spinner>
        </span>
        <span *ngIf="!loadingDistribuidoras">
          <mat-form-field class="example-full-width">
            <input
              matInput
              placeholder="Distribuidora"
              [matAutocomplete]="auto1"
              formControlName="distribuidoraCtrl"
            />
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="displayFnDist"
            >
              <mat-option
                *ngFor="let distribuidora of filteredDistribuidoras | async"
                [value]="distribuidora"
              >
                <span>{{ distribuidora.valor }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </span>
      </div>
      <div class="col s12 m6 l2">
        <mat-form-field>
          <input
            formControlName="fechaInicial"
            readonly
            matInput
            [matDatepicker]="picker"
            placeholder="Fecha Inicial"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col s12 m6 l2">
        <mat-form-field>
          <input
            formControlName="fechaFinal"
            readonly
            matInput
            [matDatepicker]="picker1"
            placeholder="Fecha Final"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col s12 m12 l2">
        <button
          mat-raised-button
          color="accent"
          type="submit"
          [disabled]="!filtroGroup.valid || loading"
        >
          Consultar
        </button>
      </div>
    </div>
  </form>
</div>
